var _path, _path2, _path3, _path4, _g, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExodus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 100,
    viewBox: "0 0 180 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3698_3456)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.4329 42.967L30.9668 34.1377V39.0742L39.6054 44.6877L38.5892 47.9035H30.9668V51.9937H38.5892L39.6054 55.2095L30.9668 60.823V65.7596L44.4329 56.9585L42.2308 49.9627L44.4329 42.967Z",
    fill: "#0B46F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2509 51.9937H26.845V47.9035H19.2227L18.2346 44.6877L26.845 39.0742V34.1377L13.3789 42.967L15.5809 49.9627L13.3789 56.9585L26.8732 65.7596V60.823L18.2346 55.2095L19.2509 51.9937Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3698_3456",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 34,
    width: 32,
    height: 32
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4329 42.967L30.9668 34.1377V39.0742L39.6054 44.6877L38.5892 47.9035H30.9668V51.9937H38.5892L39.6054 55.2095L30.9668 60.823V65.7596L44.4329 56.9585L42.231 49.9627L44.4329 42.967Z",
    fill: "url(#paint0_linear_3698_3456)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2509 51.9937H26.845V47.9035H19.2227L18.2346 44.6877L26.845 39.0742V34.1377L13.3789 42.967L15.5809 49.9627L13.3789 56.9585L26.8732 65.7596V60.823L18.2346 55.2095L19.2509 51.9937Z",
    fill: "url(#paint1_linear_3698_3456)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3698_3456)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.2268 34.1377H13.3955V65.7596H44.2268V34.1377Z",
    fill: "white"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2235 42.834V45.5985H58.4832V48.4273H69.3082V51.1918H58.4832V54.2992H71.2235V57.0638H55.2148V42.834H71.2235Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0303 57.0638L80.3499 49.8631L73.2377 42.834H77.7373L82.7554 47.913L87.566 42.834H91.7753L84.6838 49.8631L92.0034 57.0638H87.4622L82.7554 51.8348L77.3848 57.0638H73.0303Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M100.781 42.834C106.711 42.834 110.278 45.8037 110.278 49.9489C110.278 54.0941 106.711 57.0638 100.781 57.0638C94.8507 57.0638 91.3047 54.0941 91.3047 49.9489C91.3047 45.8037 94.8507 42.834 100.781 42.834ZM100.781 45.4943C97.2147 45.4943 94.5858 47.2885 94.5858 49.9489C94.5858 52.6092 97.2147 54.4035 100.781 54.4035C104.368 54.4035 106.997 52.6092 106.997 49.9489C106.997 47.2885 104.368 45.4943 100.781 45.4943Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M122.099 42.834C126.849 42.834 129.711 45.4699 129.711 49.9275C129.711 54.4278 126.869 57.0638 122.14 57.0638H112.517V42.834H122.099ZM126.351 49.9275C126.351 47.1415 124.692 45.5985 121.684 45.5985H115.773V54.2992H121.684C124.692 54.2992 126.351 52.7349 126.351 49.9275Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M140.481 57.0638C135.48 57.0638 131.687 54.7937 131.687 50.6109V42.834H134.959V50.2957C134.959 52.8811 137.647 54.0792 140.481 54.0792C143.336 54.0792 146.025 52.902 146.025 50.2957V42.834H149.276V50.6109C149.276 54.7937 145.504 57.0638 140.481 57.0638Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M158.435 57.0638C155.748 57.0638 152.851 56.5689 150.794 55.6409L151.865 53.001C153.712 53.8466 156.252 54.3829 158.54 54.3829C161.164 54.3829 163.62 53.826 163.62 52.8361C163.62 52.1143 162.844 51.8049 161.227 51.5574L156.651 51.0625C153.124 50.5881 151.403 49.3715 151.403 47.2267C151.403 44.4632 154.321 42.834 158.603 42.834C161.185 42.834 164.733 43.3083 166.559 44.1332L165.489 46.6492C163.683 45.9068 160.618 45.5356 158.456 45.5356C156.231 45.5356 154.761 46.0512 154.761 46.9998C154.761 47.6597 155.496 47.9897 157.386 48.2578L161.836 48.7528C165.237 49.2271 167 50.3819 167 52.6299C167 55.4758 163.263 57.0638 158.435 57.0638Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3698_3456",
    x1: 40.0767,
    y1: 67.9336,
    x2: 31.0564,
    y2: 30.665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B46F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBFBE0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3698_3456",
    x1: 40.0765,
    y1: 67.9336,
    x2: 31.0562,
    y2: 30.665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B46F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBFBE0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3698_3456"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 154,
    height: 31.724,
    fill: "white",
    transform: "translate(13 34.1377)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExodus);
export default __webpack_public_path__ + "static/media/Exodus.e97b820b135d81692f87cde8f11bad12.svg";
export { ForwardRef as ReactComponent };